<template>
  <div>
    <van-nav-bar
        title="收货地址"
        left-arrow
        class="my-nav"
        :fixed="true"
        @click-left="returnLeft"
    />
    <div style="margin-top: 50px;">

      <van-address-list
          v-model="chosenAddressId"
          :list="list"
          @edit="onEdit"
          @select="onSelect"
      >
        <div class="cover-address"></div>
        <van-button v-if="isAdd" block round type="danger" class="van-address-list__add" style="z-index: 10001; "
                    @click="onAdd">新增地址
        </van-button>
        <!--        <van-button v-if="!isAdd" disabled block type="danger" class="van-address-list__add" style="z-index: 10001;">-->
        <!--          最多添加三个收货地址-->
        <!--        </van-button>-->
      </van-address-list>
    </div>

  </div>
</template>

<script>
import {Toast} from 'vant'
import {listAddress, updateDefaultAddress, getIfShowAddBtn, canAdd} from '../../api/address';
import bus from "../../bus";

export default {
  data() {
    return {
      chosenAddressId: '',
      list: [
        /* {
           id: '1',
           name: '张三',
           tel: '13000000000',
           address: '浙江省杭州市西湖区文三路 138 号东方通信大厦 7 楼 501 室'
         },
         {
           id: '2',
           name: '李四',
           tel: '1310000000',
           address: '浙江省杭州市拱墅区莫干山路 50 号'
         }*/
      ],
      debug: false,
      chosenAddress: undefined,
      isAdd: false
    }
  },
  async mounted() {
    listAddress(d => {
      for (let i of d.data) {
        let obj = {}
        obj.id = i.id
        obj.name = i.name
        obj.tel = i.phone
        obj.enabled = i.enabled
        obj.address = i.region + ',' + i.address
        if (true == i.enabled) {
          this.chosenAddressId = i.id
        }
        this.list.push(obj)
      }

      // this.getIfShowAddBtn();
    })

    this.isAdd = await canAdd()
  },
  methods: {
    getIfShowAddBtn() {
      if (bus.state.buyList.length) {
        let shopId;
        let skuCodes = [];
        bus.state.buyList.forEach(buy => {
          shopId = buy.id,
              skuCodes.push(buy.commodity.map(s => {
                return s.skuCode
              }))
        });
        console.log(skuCodes)
        getIfShowAddBtn({shopId, skuCodes: skuCodes.join(",")}, data => {
          this.debug = data
          //如果不是直发商品选中后台默认地址
          if (data) {
            let address = bus.state.tempAddress;
            if (address) {
              let enableAddress = bus.state.enableAddress;
              if (enableAddress) {
                this.chosenAddressId = enableAddress.id
              } else {
                this.chosenAddressId = address.id
              }
              this.list.push(Object.assign(address, {address: address.region + ',' + address.address}))
            }
          }
        }, e => {
          Toast.fail("是否添加临时地址信息获取失败!");
        })
      }

    },
    toSubmitAddress(item) {
      let submitAddress = {
        id: item.id,
        name: item.name,
        enabled: item.enabled,
        phone: item.tel,
        region: item.address.split(',')[0].replace(/-/g, " "),
        address: item.address.split(',')[1]
      }
      return submitAddress;
    },
    onAdd() {
      if (this.isAdd) {
        this.$router.push('address-edit')
      }

    },
    onEdit(item) {
      if (this.isAdd) {
        this.$router.push({path: 'address-edit', query: {id: item.id}});
      } else {
        this.$toast({message: '修改地址请联系业务', position: 'top',});
      }
    },
    onSelect(item) {

      if (item.id) {
        updateDefaultAddress(item.id, () => Toast('设置默认收货地址成功!'), () => Toast('设置默认收货地址失败!'))
      }
      let submitAddress = this.toSubmitAddress(item);
      console.log(item, submitAddress)
      bus.state.enableAddress = submitAddress
    },
    returnLeft() {
      this.$router.back(-1);
    }
  },
  computed: {
    // isAdd() {
    //   // return this.list.length<3;
    //   return true;
    // }
  },
  watch: {
    '$route'() {
      this.debug = this.$route.query.debug
    }
  }

}
</script>

<style lang="less" scoped>
.van-address-list__add {
  height: 50px
}

.cover-address {
  z-index: 10000;
  background: rgb(255, 255, 255);
  width: 100%;
  height: 60px;
  position: fixed;
  bottom: 0;
  left: 0;
}
</style>
